import React from 'react';
import { TimeRangePicker } from './TimeRangePicker';
import { daysOfWeek } from '../../../constants';

export const WeeklyAvailability = ({ 
  weeklyHours, 
  setWeeklyHours, 
  saveSchedule,
  addTimeSlot,
  removeTimeSlot,
  updateSlot
}) => {
  return (
    <div className="col-12 col-lg-6">
      <div className="card-body">
        <h2 className="card-title h4">Tutor Availability</h2>
        <p className="text-muted mb-0">Set your weekly teaching schedule</p>

        <div className="accordion mt-4" id="availabilityAccordion">
          {daysOfWeek.map(day => {
            const { enabled, slots = [], errors = {} } = weeklyHours[day] || { enabled: false, slots: [], errors: {} };
            return (
              <div key={day} className="card mb-3 border">
                <div className="card-body">
                  <div className="d-flex flex-wrap align-items-center mb-3">
                    <div className="form-check me-auto">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`day-${day}`}
                        checked={enabled}
                        onChange={() => {
                          setWeeklyHours(prev => ({
                            ...prev,
                            [day]: {
                              enabled: !prev[day]?.enabled,
                              slots: !prev[day]?.enabled ? [{ startTime: '09:00:00', endTime: '17:00:00' }] : [],
                              errors: {}
                            }
                          }));
                        }}
                      />
                      <label className="form-check-label fw-medium" htmlFor={`day-${day}`}>{day}</label>
                    </div>
                    {enabled && (
                      <button
                        onClick={() => addTimeSlot(day)}
                        className="btn btn-link text-primary text-decoration-none mt-2 mt-sm-0"
                      >
                        +
                      </button>
                    )}
                  </div>
                  {enabled && slots.map((slot, index) => (
                    <TimeRangePicker
                      key={index}
                      startTime={slot.startTime}
                      endTime={slot.endTime}
                      onStartTimeChange={(time) => updateSlot(day, index, 'startTime', time)}
                      onEndTimeChange={(time) => updateSlot(day, index, 'endTime', time)}
                      onRemove={() => removeTimeSlot(day, index)}
                      error={errors[index]}
                    />
                  ))}
                  {!enabled && (
                    <div className="text-muted small ms-4">Not Available</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div className="d-flex justify-content-end">
          <button className="btn btn-primary mt-2" onClick={saveSchedule}>
            <i className="bi bi-save me-2"></i>Save Schedule
          </button>
        </div>
      </div>
    </div>
  );
};